export const SLUG_CATEGORY = `category`;
export const SLUG_PRODUCT = `product`;
export const SLUG_ACCOUNT = `account`;
export const SLUG_FAVORITES = `favorites`;
export const SLUG_ORDERS = `orders`;
export const SLUG_ORDER = `order`;
export const SLUG_CART = `cart`;
export const SLUG_DELIVERY = `delivery`;
export const SLUG_RECAP = `recap`;
export const SLUG_CONFIRMATION = `order-confirmed`;
